import { Component, OnInit, Output, EventEmitter, Input , OnDestroy} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService, UsersService } from 'app/services';
import { takeUntil } from 'rxjs/operators';
import { User } from 'app/models';
import { Subject } from 'rxjs';
import { SubscriptionService } from 'app/services/subscription-service/subscription.service';

@Component({
  standalone: false,
  selector: 'app-company-dashboard',
  templateUrl: './company-dashboard.component.html',
  styleUrls: ['./company-dashboard.component.scss']
})
export class CompanyDashboardComponent implements OnInit, OnDestroy {
  @Output() tabActive = new EventEmitter<boolean>();
  @Output() subscriptionTabActive = new EventEmitter<boolean>();
  activeUserCount: number = 0;
  subscriptionCount: number = 0;
  usersError: string;
  blockedUsers: User[]=[];
  companyId: string;
  private onDestroy$ = new Subject<void>();
  userHasAccess: boolean;
  @Input()
  usersProfile: Subject<any[]>;
  constructor(
    private _router: Router,
    private _usersService: UsersService,
    private readonly _subscriptionService: SubscriptionService,
    private readonly authService: AuthService,
    private route: ActivatedRoute
  ) {} 

  ngOnInit() {
    this.getUsers();
    this.companyId = this.route.snapshot.params['id'];

    this._subscriptionService.subscriptions$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(subscriptions => {
        this.subscriptionCount = subscriptions ? subscriptions.length : 0;
      });

    this._usersService.getUsersByCompanyId(this.companyId, false)
    this.usersProfile.pipe(takeUntil(this.onDestroy$)).subscribe(users => {
      if (users) {
        this.activeUserCount = users ? users.length : 0;
      }
    });  
    
    this.authService.user$.subscribe(user => {
      if (user) {
        this.userHasAccess = user.isAppManager || user.isCompanyManager;
      }
    });     
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  gotoUser() {
    this.tabActive.emit(true);
  }

  gotoSubscriptions() {
    this.subscriptionTabActive.emit(true); 
  }

  gotoInactiveUser() {
    this._router.navigate(['company/deactivatedUsers',this.companyId]);
  }

  getUsers() {
    this._usersService.inactiveCompanyUsers$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(users => {
        this.blockedUsers = users;
      });
    this._usersService.error$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(error => {
        this.usersError = error;
      });
  }
}
